export default __webpack_public_path__ + "static/media/026.adcdb510.jpg";